import { Alert } from 'zui/Antd';

//!! This component is deprecated and should be removed in the future
function WarningAlert({ message, marginBottom = 12 }) {
	return (
		<Alert
			message={message ?? 'Warning'}
			type='warning'
			showIcon
			closable
			style={{ marginBottom: marginBottom, width: '100%' }}
		/>
	);
}

export default WarningAlert;
